// extracted by mini-css-extract-plugin
export default {"ContactsList":"styles_ContactsList__9prct","header":"styles_header__9wzIO","list":"styles_list__Up0B8"};